<template>
  <button class="btn btn-info rounded-pill" href="#" @click="openFaqWindow" @mousedown.prevent="removeFocus">
    <img src="\img\icon\icon-faq.png" width="52" height="26">
  </button>
</template>

<script>

export default {
  name: 'FaqButton',
  components: {
  },
  computed: {
  },
  methods: {
    openFaqWindow() {
      window.open("/faq", "broker-faq.jyurep");
    },
    removeFocus(event) {
      event.target.blur();
    },
  },
}
</script>
